import { getCookie } from 'utils/storage';
import {
  APP_VERSION_KEY,
  APPLICATION_ID_KEY,
  PID_KEY,
  SID_KEY,
  STOREFRONT_ID_KEY,
  TOKEN_KEY,
  UNIQUEID_KEY,
  AB_COOKIE_KEY,
} from 'constants/storageKeys';

export const cookieStorage = {
  token: '',
  applicationId: '',
  storefrontId: '',
  abTestingValues: '',
  version: '',
  pid: '',
  sid: '',
  uniqueId: '',
};

export const applicationService = {
  getToken: (): string | null => {
    const { token } = cookieStorage;
    if (token === '') {
      const userToken =
        window.localStorage.getItem(TOKEN_KEY) || getCookie(TOKEN_KEY);

      if (!userToken?.trim()) {
        return null;
      }
      cookieStorage.token = userToken;
      return userToken;
    }
    return token;
  },
  setToken: (token: string | null): void => {
    if (token) {
      window.localStorage.setItem(TOKEN_KEY, token);
    }
  },
  getApplicationId: (): string | null => {
    const { applicationId } = cookieStorage;
    if (applicationId === '') {
      const appId =
        window.localStorage.getItem(APPLICATION_ID_KEY) ||
        getCookie(APPLICATION_ID_KEY);

      if (!appId?.trim()) {
        return null;
      }
      cookieStorage.applicationId = appId;

      return appId;
    }
    return applicationId;
  },
  setApplicationId: (id: string | null): void => {
    if (id) {
      window.localStorage.setItem(APPLICATION_ID_KEY, id);
    }
  },
  getStoreFrontId: (): string | null => {
    const { storefrontId } = cookieStorage;

    if (storefrontId === '') {
      const sfid =
        window.localStorage.getItem(STOREFRONT_ID_KEY) ||
        getCookie(STOREFRONT_ID_KEY);
      if (!sfid?.trim()) {
        return null;
      }
      cookieStorage.storefrontId = sfid;
      return sfid;
    }
    return storefrontId;
  },
  setStoreFrontId: (id: string | null): void => {
    if (id) {
      window.localStorage.setItem(STOREFRONT_ID_KEY, id);
    }
  },
  getPid: (): string | null => {
    const { pid } = cookieStorage;
    if (pid) return pid;

    const pId = getCookie(PID_KEY) || window.localStorage.getItem(PID_KEY);
    if (pId) cookieStorage.pid = pId;
    return pId;
  },
  setPid: (pid: string | null): void => {
    if (pid) {
      window.localStorage.setItem(PID_KEY, pid);
    }
  },
  getSid: (): string | null => {
    const { sid } = cookieStorage;
    if (sid) return sid;

    const sId = getCookie(SID_KEY) || window.localStorage.getItem(SID_KEY);
    if (sId) cookieStorage.sid = sId;
    return sId;
  },
  setSid: (sid: string | null): void => {
    if (sid) {
      window.localStorage.setItem(SID_KEY, sid);
    }
  },
  getUniqueId: (): string | null => {
    const { uniqueId } = cookieStorage;
    if (uniqueId) return uniqueId;

    const uId =
      getCookie(UNIQUEID_KEY) || window.localStorage.getItem(UNIQUEID_KEY);
    if (uId) cookieStorage.uniqueId = uId;
    return uId;
  },
  setUniqueId: (uniqueId: string | null): void => {
    if (uniqueId) {
      window.localStorage.setItem(UNIQUEID_KEY, uniqueId);
    }
  },
  getAppVersion: (): string | undefined => {
    const { version } = cookieStorage;
    if (version) return version;

    const appVersion = getCookie(APP_VERSION_KEY);
    if (appVersion) cookieStorage.version = appVersion;
    return appVersion;
  },
  getAbTestingValues: (): string | undefined => {
    const { abTestingValues } = cookieStorage;
    if (abTestingValues) return abTestingValues;

    const abCookie = getCookie(AB_COOKIE_KEY);
    if (abCookie) cookieStorage.abTestingValues = abCookie;
    return abCookie;
  },
};
